export default "__VITE_ASSET__DluoRMDz__"